export class EventDispatcher {
  static send(type, detail) {
    const event = new CustomEvent(type, { 
      detail
    })

    window.dispatchEvent(event)
  }
}